"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
exports.t = {
    en: {
        calibration: "Calibration",
        open_exercise: "Go to the exercise",
    },
    ru: {
        calibration: "Калибровка",
        open_exercise: "Перейти к упражению",
    },
    uz: {
        calibration: "Kalibrlash",
        open_exercise: "Mashqga o'tish",
    },
    kz: {
        calibration: "Калибрлеу",
        open_exercise: "Жаттығуға өту",
    }
};
